import React, { useState, useEffect, useContext } from "react";
import EChartsReact from "echarts-for-react";
import { fetchConfAdnNcData } from "../../../src/pages/servicePerformance/kpiService";
import { FilterContext } from "../../context/Filter";

const Confcard = () => {
  const [confAdnNcData, setConfAdnNcData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchConfAdnNcDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchConfAdnNcData(parArn, childArn);
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }

      const monthMap = {
        Sep: "Sept",
        September: "Sept",
        Mar: "March",
        Jan: "Jan",
      };
      const normalizedData = apiData.map((item) => ({
        ...item,
        month: monthMap[item.month] || item.month,
      }));

      setConfAdnNcData(normalizedData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
    } finally {
      setLoading(false);
    }
  };
  const { superArn: parArn, childArn } = useContext(FilterContext);
  useEffect(() => {
    // const urlParams = new URLSearchParams(window.location.search);
    // const parArn = urlParams.get("arn");
    // const childArn = urlParams.get("childArn");
    fetchConfAdnNcDataAPI(parArn, childArn);
  }, [parArn, childArn]);

  const allMonths = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const chartData = Array.isArray(confAdnNcData) ? confAdnNcData : [];
  const months = [...allMonths];
  const monthsWithData = [...new Set(chartData.map((item) => item.month))];

  const monthlyTotals = {};
  chartData.forEach(({ month, count }) => {
    monthlyTotals[month] = (monthlyTotals[month] || 0) + count;
  });

  const typeMapPercentage = {};
  const colorMap = {
    CONF: "#3DC293",
    NC: "#FD756A",
  };

  Object.keys(colorMap).forEach((type) => {
    typeMapPercentage[type] = Array(months.length).fill(0);
  });

  chartData.forEach(({ type, month, count }) => {
    const monthIndex = months.indexOf(month);
    if (monthIndex !== -1 && monthlyTotals[month] > 0) {
      typeMapPercentage[type][monthIndex] =
        (count / monthlyTotals[month]) * 100;
    }
  });

  const stackedSeries = Object.entries(typeMapPercentage).map(
    ([type, data]) => ({
      name: type,
      type: "bar",
      stack: "total",
      barWidth: "70%",
      itemStyle: {
        color: colorMap[type],
      },
      label: {
        show: true,
        fontSize: 9,
        fontStyle: "italic",
        fontWeight: "bold",
        formatter: (params) => {
          if (monthsWithData.includes(months[params.dataIndex])) {
            return Math.round(params.value * 10) / 10 + "%";
          }
          return "";
        },
      },
      data,
      barCategoryGap: "10%",
      z: 2, // Ensure these are on top of gray bars
    })
  );

  const grayBarData = months.map((_, index) => {
    const total = Object.keys(typeMapPercentage).reduce(
      (sum, type) => sum + typeMapPercentage[type][index],
      0
    );
    return total < 100 ? 100 - total : 0;
  });

  const grayBarSeries = {
    name: "No Data",
    type: "bar",
    stack: "total",
    barWidth: "70%",
    itemStyle: {
      color: "#CCCCCC", // darker gray for visibility
    },
    label: {
      show: false,
      fontSize: 8,
      formatter: (params) =>
        params.value > 0 ? `${Math.round(params.value)}%` : "",
    },
    data: grayBarData,
    z: 1, // Render behind other bars
  };

  const option = {
    tooltip: {
      trigger: "axis",
      valueFormatter: (value) => Math.round(value * 10) / 10 + "%",
      formatter: (params) => {
        const monthName = params[0].axisValue;
        if (!monthsWithData.includes(monthName)) {
          return `<p>${monthName}</p><br/>No data available`;
        }

        let totalPercentage = 0;
        let lines = params
          .filter((p) => p.seriesName !== "No Data" && p.value > 0)
          .map((p) => {
            totalPercentage += p.value;
            return `${p.marker} ${p.seriesName}: ${Math.round(p.value * 10) / 10
              }%`;
          });

        return [
          `<b>${monthName}</b>`,
          ...lines,
          `<br/>Total: ${Math.round(totalPercentage * 10) / 10}%`,
        ].join("<br/>");
      },
    },
    legend: {
      top: 10,
      left: "center",
      selectedMode: true,
      data: [...Object.keys(typeMapPercentage), "No Data"],
    },
    grid: {
      left: 50,
      right: 50,
      top: 60,
      bottom: 50,
    },
    yAxis: {
      type: "value",
      splitLine: { show: false },
      axisLabel: {
        show: false,
      },
      max: 100,
    },
    xAxis: {
      type: "category",
      data: months,
      axisLabel: {
        interval: 0,
        rotate: 45,
      },
      axisLine: {
        show: true,
      },
      axisTick: {
        show: false,
      },
    },
    series: [grayBarSeries, ...stackedSeries],
  };

  return (
    <div className="w-full">
      <EChartsReact option={option} style={{ height: "220px" }} />
    </div>
  );
};

export default Confcard;
